export const steps = {
  PREFACE: 'preface',
  PAYMENT: 'payment',
  PLAN_SELECTION: 'planSelection',
  CONFIRMATION: 'confirmation',
  DOWNGRADE_TIER: 'downgradeTier',
  UPGRADE_TIER: 'upgradeTier',
  INCREASE_QUANTITY: 'increaseQuantity',
  SUPPORT: 'support',
  CONTACT_ADMIN: 'contactAdmin',
  CONTACT_ADMIN_NO_SEATS: 'contactAdminNoSeats',
  PROMPT_TO_REMOVE_SCHEDULED_DOWNGRADE: 'promptToRemoveScheduledDowngrade',
  FREQUENCY_PROMPT_TO_REMOVE_SCHEDULED_DOWNGRADE: 'frequencyPromptToRemoveScheduledDowngrade',
  PROMPT_TO_REMOVE_NON_RENEWING_DOWNGRADE: 'promptToRemoveNonRenewingDowngrade',
  FEATURE_LOCKED_MODAL: 'featureLockedModal',
  LEGACY_PLAN_MODAL: 'legacyPlanModal',
  QUICK_PURCHASE: 'quickPurchase',
  APPLE_SUBSCRIPTION_MODAL: 'appleSubscriptionModal',
  SUBSCRIPTION_PAUSED: 'subscriptionPausedModal',
  SUBSCRIPTION_PAYMENT_PENDING: 'subscriptionPaymentPendingModal',
  REMOVE_SCHEDULED_PAUSE: 'removeScheduledPauseModal'
}
